import Link from "components/base/Link";
import Button from "components/elements/Button";
import { abbreviation } from "helpers";
import React from "react";

export function Hit({ hit, label }: any) {

    const Avatar = () => {
        return (
            <div
                className={`flex h-8 w-8 items-center justify-center rounded-full bg-primary-600 text-white text-sm font-light select-none`}
            >
                {abbreviation(hit.name)}
            </div>
        );
    };

    return (
        <div className="flex items-center space-x-4 border bg-primary-25 rounded-lg my-4 p-4">
            <div className="flex-shrink-0">
                {hit.brandkit.logo_large ? (
                    <img className="w-8 h-8 rounded-full" src={hit.brandkit.logo_large} alt="Neil image"/>
                ) : (
                    <Avatar/>
                )}
            </div>
            <div className="flex-1 min-w-0">
                <p className="text-sm font-medium text-gray-900 truncate">
                    {hit.name}
                </p>
                <p className="text-sm text-gray-500 truncate ">
                    <Link to={hit.url}>
                        {hit.website}
                    </Link>
                </p>
            </div>
            <div className="inline-flex items-center text-base font-semibold text-gray-900 ">
                <Button id="check-balance-button" variant={"ghost"} size={"medium"}>
                    <Link to={hit.url} className={"flex font-medium"} isExternalLink={true}>
                        {label}
                        <div className={"flex items-center ml-2"}>
                            <svg
                                width="14"
                                height="14"
                                viewBox="0 0 14 14"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path
                                    d="M1.16797 7.00008H12.8346M12.8346 7.00008L7.0013 1.16675M12.8346 7.00008L7.0013 12.8334"
                                    stroke="#000000"
                                    strokeWidth="1.67"
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                />
                            </svg>
                        </div>
                    </Link>
                </Button>
            </div>
        </div>
    );
}